import { NextPage } from "next";
import React from "react";
import Report from "~/components/report/Report";
import safeGetQueryParameter from "~/lib/utils/safeGetQueryParameter";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";

interface IReportPageProps {
  slug: string;
}

const ReportPage: NextPage<IReportPageProps> = ({ slug }) => {
  return (
    <NavbarLayout>
      <Report slug={slug} />
    </NavbarLayout>
  );
};

ReportPage.getInitialProps = ({ query }) => {
  return {
    slug: safeGetQueryParameter(query, "reportSlug"),
  };
};

export default ReportPage;
